export default __webpack_public_path__ + "static/media/18.2f0d596b.wav";